import { FC } from "react";
import { TrashIcon } from "src/ui/assets/icons/TrashIcon";
import { ParsedObservationData } from "src/lib/fhir";
import { SimpleButton } from "atom/button/SimpleButton";
import { DELETABLE_LAB_CODES } from "./DeleteLabByCode.constant";
import { LoincCodingCode } from "src/constants/fhir";
import { PopupDialogTrigger } from "molecule/popupDialog/PopupDialogTrigger";
import { deleteLabByCodeStyled } from "./DeleteLabByCode.styled";
import { getSupportedUserLocale } from "src/lib/i18next";
import Translate from "components/Translate/Translate";

export const DeleteLabByCode: FC<{
  data: ParsedObservationData;
  unitText: string;
}> = ({ data, unitText }) => {
  const { code, value, date } = data;

  const deleteFn = DELETABLE_LAB_CODES[code as LoincCodingCode];
  if (!deleteFn) {
    return null;
  }

  const {
    DeleteDialog,
    DeleteWrapper,
    DeleteHeading,
    DeleteText,
    DeleteAction,
    DeleteDeleteButton
  } = deleteLabByCodeStyled;

  return (
    <>
      <PopupDialogTrigger>
        <SimpleButton>
          <TrashIcon />
        </SimpleButton>
        <DeleteDialog>
          <DeleteWrapper>
            <DeleteHeading>
              <Translate msg={"deleteLabByCode.title"} />
            </DeleteHeading>
            <DeleteText>
              <Translate
                msg={"deleteLabByCode.confirmation"}
                variables={{
                  value,
                  unitText,
                  date: date.toDate().toLocaleString(getSupportedUserLocale(), {
                    month: "short",
                    day: "numeric"
                  })
                }}
              />
            </DeleteText>
            <DeleteAction>
              <SimpleButton slot={"close"}>
                <Translate msg={"cancel"} />
              </SimpleButton>
              <DeleteDeleteButton
                slot={"close"}
                onClick={() => void deleteFn(data)}
              >
                <Translate msg={"delete"} />
              </DeleteDeleteButton>
            </DeleteAction>
          </DeleteWrapper>
        </DeleteDialog>
      </PopupDialogTrigger>
    </>
  );
};
